module.exports = __webpack_public_path__ + "static/james-ross-37b9eef1f1aebdfa059c3f19a6a25494.png";